export const CLEAR_ERROR = "CLEAR_ERROR";
export const SET_ERROR = "SET_ERROR";

export const ERROR_TYPE = { generic: 1, network: 2, server: 3 };
